import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import QuickSelector from './quick-selector';
import StudentHeader from './student-header';
import StudentListItem from './student-list-item';

import { Root, HeaderContainer, StudentListItemWrapper } from './styled';

const StudentList = props => {
  const { i18n } = props;

  /**
   * Store
   */
  const sortedStudentIds = useSelector(state => state.UPFAssignReducer.sortedStudentIds);

  return (
    <Root id="studentList">
      <HeaderContainer>
        <StudentHeader i18n={i18n} />
        <QuickSelector i18n={i18n} />
      </HeaderContainer>
      <StudentListItemWrapper>
        {sortedStudentIds.map(studentId => (
          <StudentListItem key={studentId} studentId={studentId} i18n={i18n} />
        ))}
      </StudentListItemWrapper>
    </Root>
  );
};

StudentList.propTypes = {
  i18n: PropTypes.object
};

export default StudentList;
